export default __webpack_public_path__ + "static/media/drag-tutorial.bd99e358.png";